import Box from "ds/components/Box";

import { WorkerUsageData } from "../types";
import UsageWorkersNewMetricCard from "./Card";
import { getWorkerUsageCards } from "./utils";

type UsageWorkersNewMetricCardsProps = {
  usage: WorkerUsageData;
};

const UsageWorkersNewMetricCards = ({ usage }: UsageWorkersNewMetricCardsProps) => (
  <Box direction="row" wrap gap="large" fullWidth>
    {getWorkerUsageCards(usage).map((card) => (
      <UsageWorkersNewMetricCard key={card.label} {...card} />
    ))}
  </Box>
);

export default UsageWorkersNewMetricCards;
